import { render } from "./equipamentosView.vue?vue&type=template&id=62a20ed6&scoped=true"
import script from "./equipamentosView.vue?vue&type=script&lang=js"
export * from "./equipamentosView.vue?vue&type=script&lang=js"

import "./equipamentosView.vue?vue&type=style&index=0&id=62a20ed6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a20ed6"]])

export default __exports__